export default __webpack_public_path__ + "7be80bc47fdf3c8d354d158e4a0ca80f.png";